<template>
    <div>
        <div class="col-12 flexbox">
            <div class="chart1 flex-margin-auto" />
        </div>
        <!-- <div v-show="!PalmLineageData" class="empty-palm-lineage">
            <span>No Lineage Data</span>
        </div> -->
    </div>
</template>

<script>
import Vue from "vue";
import * as d3 from "d3";
Vue.use(d3);
import { palmGetLineage } from "@/api/palm";

export default {
    props: ["palmId"],
    data () {
        return {
            msg: "Tree Lineage",
            PalmLineageData: "",
        };
    },
    watch: {
        palmId: function () {
            var self = this;
            this.$nextTick(function () {
                $(".chart1").empty();
                setTimeout(function() {self.getPalmLineage(); },500);
            });
			  }
    },
    mounted() {
        var self = this;
        this.$nextTick(function () {
            self.getPalmLineage();
        });
    },
    methods: {
        async getPalmLineage() {
            let res = await palmGetLineage({ Id: this.palmId });
            if (res) {
                this.PalmLineageData = res;
                this.drawGraph();
            }
        },
        drawGraph() {
            // Set the dimensions and margins of the diagram
            var margin = { top: 20, right: 90, bottom: 30, left: 150 },
				    width = 960 - margin.left - margin.right,
				    height = 400 - margin.top - margin.bottom;

            var zoom = d3.zoom()
				  .scaleExtent([1, 10])
				  .on("zoom", zoomed);

            // append the svg object to the body of the page
            // appends a 'group' element to 'svg'
            // moves the 'group' element to the top left margin
            var svg = d3.select(".chart1").append("svg")
				    .attr("width", width + margin.right + margin.left)
				    .attr("height", height + margin.top + margin.bottom)
				  .append("g")
				    .attr("transform", "translate("
				          + margin.left + "," + margin.top + ")")
				  .call(zoom);

            function zoomed() {
				  	d3.select(".chart1").attr("transform", "translate(" + d3.event.translate + ")scale(" + d3.event.scale + ")");
            }

            var i = 0,
				    duration = 750,
				    root;

            // declares a tree layout and assigns the size
            var treemap = d3.tree().size([height, width]);

            // Assigns parent, children, height, depth
            root = d3.hierarchy(this.PalmLineageData, function(d) { return d.children; });
            root.x0 = height / 2;
            root.y0 = 0;

            // Collapse after the second level
            //root.children.forEach(collapse);

            update(root);

            // Collapse the node and all it's children
            // function collapse(d) {
            //   if(d.children) {
            //     d._children = d.children
            //     d._children.forEach(collapse)
            //     d.children = null
            //   }
            // }

            function update(source) {

				  // Assigns the x and y position for the nodes
				  var treeData = treemap(root);

				  // Compute the new tree layout.
				  var nodes = treeData.descendants(),
				      links = treeData.descendants().slice(1);

				  // Normalize for fixed-depth.
				  nodes.forEach(function(d) { d.y = d.depth * 180;});

				  // ****************** Nodes section ***************************

				  // Update the nodes...
				  var node = svg.selectAll("g.node")
				      .data(nodes, function(d) {return d.id || (d.id = ++i); });

				  // Enter any new modes at the parent's previous position.
				  var nodeEnter = node.enter().append("g")
				      .attr("class", "node")
				      .attr("transform", function(d) {
				        return "translate(" + source.y0 + "," + source.x0 + ")";
				    })
				    .on("click", click);

				  // Add Circle for the nodes
				  nodeEnter.append("circle")
				      .attr("class", "node")
				      .attr("r", 1e-6)
				      .style("fill", function(d) {
				          return d._children ? "lightsteelblue" : "#fff";
				      });

				  // Add labels for the nodes
				  nodeEnter.append("text")
				      .attr("dy", ".35em")
				      .attr("x", function(d) {
				          return d.children || d._children ? -13 : 13;
				      })
				      .attr("text-anchor", function(d) {
				          return d.children || d._children ? "end" : "start";
				      })
				      .text(function(d) { return d.data.name; });

				  // UPDATE
				  var nodeUpdate = nodeEnter.merge(node);

				  // Transition to the proper position for the node
				  nodeUpdate.transition()
				    .duration(duration)
				    .attr("transform", function(d) { 
				        return "translate(" + d.y + "," + d.x + ")";
				     });

				  // Update the node attributes and style
				  nodeUpdate.select("circle.node")
				    .attr("r", 10)
				    .style("fill", function(d) {
				        return d._children ? "lightsteelblue" : "#fff";
				    })
                    .style("stroke", function(d) {
                        if (d.data.isHavingGermplasmBlood) return "#f27d6b";
                        else return "steelblue";
                    })
				    .attr("cursor", "pointer");


				  // Remove any exiting nodes
				  var nodeExit = node.exit().transition()
				      .duration(duration)
				      .attr("transform", function(d) {
				          return "translate(" + source.y + "," + source.x + ")";
				      })
				      .remove();

				  // On exit reduce the node circles size to 0
				  nodeExit.select("circle")
				    .attr("r", 1e-6);

				  // On exit reduce the opacity of text labels
				  nodeExit.select("text")
				    .style("fill-opacity", 1e-6);

				  // ****************** links section ***************************

				  // Update the links...
				  var link = svg.selectAll("path.link")
				      .data(links, function(d) { return d.id; });

				  // Enter any new links at the parent's previous position.
				  var linkEnter = link.enter().insert("path", "g")
				      .attr("class", "link")
				      .attr("d", function(d) {
				        var o = { x: source.x0, y: source.y0 };
				        return diagonal(o, o);
				      });

				  // UPDATE
				  var linkUpdate = linkEnter.merge(link);

				  // Transition back to the parent element position
				  linkUpdate.transition()
				      .duration(duration)
				      .attr("d", function(d) { return diagonal(d, d.parent); });

				  // Remove any exiting links
				  var linkExit = link.exit().transition()
				      .duration(duration)
				      .attr("d", function(d) {
				        var o = { x: source.x, y: source.y };
				        return diagonal(o, o);
				      })
				      .remove();

				  // Store the old positions for transition.
				  nodes.forEach(function(d) {
				    d.x0 = d.x;
				    d.y0 = d.y;
				  });

				  // Creates a curved (diagonal) path from parent to the child nodes
				  function diagonal(s, d) {

				    var path = `M ${s.y} ${s.x}
				            C ${(s.y + d.y) / 2} ${s.x},
				              ${(s.y + d.y) / 2} ${d.x},
				              ${d.y} ${d.x}`;

				    return path;
				  }

				  // Toggle children on click.
				  function click(d) {
				    if (d.children) {
				        d._children = d.children;
				        d.children = null;
				      } else {
				        d.children = d._children;
				        d._children = null;
				      }
				    update(d);
				  }
            }
				
        },
    },
};
</script>
<style>
.link {
  fill: none;
  stroke: #555;
  stroke-opacity: 0.4;
  stroke-width: 1.5px;
}

.node circle {
  fill: #fff;
  stroke: steelblue;
  stroke-width: 3px;
}

.node text {
  font: 12px sans-serif;
}

.link {
  fill: none;
  stroke: #212121;
  stroke-width: 2px;
  stroke-opacity: 0.4;
}
</style>
<style scoped>
	.chart1{
		height: auto;
		overflow-x: scroll;
	}
	.empty-palm-lineage {
		min-height: 200px;
		display: flex;
		justify-content: center;
		align-content: center;
		background-color: #f3f3f3;
	}
	.empty-palm-lineage span{
		display: inline-block;
		margin: auto;
		color: var(--normal-grey);
	}
</style>


// WEBPACK FOOTER //
// src/components/Palm/PalmLineageEnlarge.vue